var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#EC4899",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1622_79730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4796 18.5278C45.6258 17.847 44.9584 17.273 44.3073 17.5214L16.0654 28.3026C15.8994 28.366 15.7564 28.4782 15.6555 28.6245C15.5546 28.7708 15.5003 28.9442 15.5 29.122C15.4997 29.2997 15.5532 29.4734 15.6536 29.62C15.754 29.7667 15.8964 29.8795 16.0622 29.9435L23.9959 33.0077V42.6587C23.9959 42.8565 24.0626 43.0485 24.1852 43.2037C24.3078 43.3588 24.4792 43.4681 24.6716 43.5139C24.864 43.5596 25.0662 43.5391 25.2455 43.4557C25.4248 43.3723 25.5708 43.2308 25.6597 43.0542L28.941 36.5429L36.9486 42.4856C37.4357 42.8471 38.1358 42.6172 38.3131 42.0362C45.7895 17.5234 45.4663 18.5894 45.4796 18.5278ZM38.5081 21.6167L24.7503 31.4146L18.8307 29.1284L38.5081 21.6167ZM25.7537 32.858L37.7459 24.3176C27.4268 35.2036 27.9657 34.6306 27.9207 34.6912C27.8539 34.7812 28.037 34.4306 25.7537 38.9616V32.858ZM36.9953 40.3313L29.9468 35.1003L42.6914 21.6554L36.9953 40.3313Z",
    fill: "#EC4899"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1622_79730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15.5 15.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasic);
export default __webpack_public_path__ + "static/media/basic.a2b78a6d8060a13b0342901f7246965b.svg";
export { ForwardRef as ReactComponent };